import * as React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { OverridableStringUnion } from '@mui/types';
import { CircularProgressPropsColorOverrides } from '@mui/material/CircularProgress/CircularProgress';

interface CircularProgressWithLabelProps extends Omit<CircularProgressProps, 'value'> {
  value: number;
  getColorFunc: (
    value: number,
  ) => OverridableStringUnion<
    'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit',
    CircularProgressPropsColorOverrides
  >;
}

const CircularProgressWithLabel = ({ value, getColorFunc, ...props }: CircularProgressWithLabelProps) => {
  const progressColor = getColorFunc(value);
  const label = `${value}%`;

  return (
    <Box
      sx={{
        position: 'relative',
        width: 120,
        height: 120,
        display: 'inline-flex',
      }}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size="100%"
        sx={{
          color: 'var(--mui-palette-text-primary)',
        }}
        {...props}
      />
      <CircularProgress
        className="circular-progress-with-label__progress"
        variant="determinate"
        value={value}
        size="100%"
        color={progressColor}
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
        }}
        {...props}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h2">{label}</Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
